import { ReactNode } from "react";
import styles from "./Pill.module.css";

type Variant = "neutral" | "info" | "success" | "warn" | "danger" | "accent";

interface Props {
  variant?: Variant;
  /** "sm" is the inline pill that rides inside a denser row — a status next to
   *  a 12.5px line of text, where the default pill would out-weigh it. */
  size?: "md" | "sm";
  /** The caller's own additions — an icon's spacing, say. */
  className?: string;
  children: ReactNode;
}

export function Pill({
  variant = "neutral",
  size = "md",
  className,
  children,
}: Props) {
  const sizeCls = size === "sm" ? ` ${styles.sm}` : "";
  const extraCls = className ? ` ${className}` : "";
  return (
    <span className={`${styles.pill} ${styles[variant]}${sizeCls}${extraCls}`}>
      {children}
    </span>
  );
}
